<div class="flex h-screen overflow-hidden">
  <app-sidebar></app-sidebar>
  <div class="flex-1 flex flex-col overflow-hidden">
    <app-navbar></app-navbar>
    <main class="flex-1 overflow-y-auto bg-gray-50">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
